import { motion } from "framer-motion";

// Real Konstantin Mobile showroom photos — self-hosted, never break
const IMAGES = [
    { src: "/img/showroom/night-exterior.jpg", alt: "Konstantin Automotive — шоурум нощем" },
    { src: "/img/showroom/interior.jpg", alt: "Интериор на шоурума с червен килим" },
    { src: "/img/showroom/aerial.jpg", alt: "Konstantin Automotive — въздушен изглед" },
    { src: "/img/showroom/mercedes.jpg", alt: "Mercedes-Benz с Konstantin.БГ регистрация" },
];

export default function Gallery() {
    return (
        <section className="relative py-28 lg:py-36" data-testid="gallery-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="mb-14 max-w-2xl">
                    <span className="block text-gold text-[11px] uppercase tracking-[0.32em] mb-5">
                        Галерия
                    </span>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest">
                        Шоурум и моменти
                    </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
                    {IMAGES.map((img, i) => (
                        <motion.div
                            key={img.src}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.7, delay: i * 0.05 }}
                            className="relative overflow-hidden rounded-2xl bg-surface border border-line group aspect-[4/3]"
                            data-testid={`gallery-item-${i}`}
                        >
                            <img
                                src={img.src}
                                alt={img.alt}
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-[1500ms] ease-out group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-bg/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
